"use strict";

var _interopRequireDefault = require("/root/workspace/follow-book_follow-book-admin_fMUT/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onRequestFulfilled = onRequestFulfilled;
exports.onRequestRejected = onRequestRejected;

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/follow-book_follow-book-admin_fMUT/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _auth = require("../../organizationLibs/vueSsoSdk/auth");

/**
 * 添加 系统 open id 请求头
 *
 * @param {object} config
 * @returns {object}
 */
function attachAppProductOpenId(config) {
  try {
    var res = config;

    if (!res.headers) {
      res.headers = {};
    }

    res.headers['Tao-Zhi-App-Product-Open-Id'] = process.env.VUE_APP_SYSTEM_OPEN_ID; // 让每个请求携带自定义token 请根据实际情况自行修改

    return res;
  } catch (e) {
    console.error(e);
    return config;
  }
}
/**
 * axios 请求前置处理器
 *
 * @param {object} config
 * @returns {Promise<{object}>}
 */


function onRequestFulfilled(_x) {
  return _onRequestFulfilled.apply(this, arguments);
}
/**
 * axios 请求错误处理器
 *
 * @param {Error} error
 */


function _onRequestFulfilled() {
  _onRequestFulfilled = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(config) {
    var res;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (config) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", config);

          case 2:
            _context.prev = 2;
            _context.next = 5;
            return (0, _auth.attachAuthorization)(config);

          case 5:
            res = _context.sent;
            return _context.abrupt("return", attachAppProductOpenId(res));

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](2);
            return _context.abrupt("return", config);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 9]]);
  }));
  return _onRequestFulfilled.apply(this, arguments);
}

function onRequestRejected(error) {
  // 这个函数似乎永远也执行不到，这里先只打一个 log，等碰到问题再处理 - [ 张久瑞 2019.10.10 ]
  console.error(error); // for debug

  throw error;
}